import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React from 'react';
import { AVATAR_SIZES } from '../../constants';
import CustomPropTypes from '../../util/custom-prop-types';
import { StyledAvatar } from './Avatar.styles';

/**
 * @since 6.10.0
 */
export var Avatar = function Avatar(props) {
  var additionalProps = {};
  if (props.fullName) {
    additionalProps['aria-label'] = props.fullName;
  }
  return /*#__PURE__*/React.createElement(StyledAvatar, _extends({}, additionalProps, props));
};
Avatar.displayName = 'Avatar';
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Considering setting this prop to `true` if the avatar is used for presentational
   * content only. In other words, if the avatar sits next to a heading with similar
   * content, then there is no need for screen readers to read both he avatar label and
   * the heading content.
   */
  'aria-hidden': PropTypes.string,
  /**
   * Provide an accessible label for the avatar.
   * Use this only if you aren't already providing alt text in your Image,
   * or if you want to provide a different value than `fullName`.
   */
  'aria-label': PropTypes.string,
  /**
   * Use `children` to provide an `Icon`,
   * `Image`, or custom text content.
   * For simple letter avatars, use the `fullName` prop instead.
   */
  'children': PropTypes.node,
  /**
   * @deprecated Use inline media query objects
   */
  'mediaQuery': CustomPropTypes.mediaQuery,
  /**
   * The `fullName` prop is used for generating simple letter avatars and
   * providing  the `aria-label` attribute. For custom letters, pass the text as `children`.
   */
  'fullName': PropTypes.string,
  /**
   * The avatar size.
   *
   * Supports inline media query objects.
   */
  'size': CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(Object.values(AVATAR_SIZES))),
  /**
   * Customize the color of the avatar.
   * When using a colored background, the text will change to white. The default background color
   * is gray.
   */
  'background': PropTypes.oneOf(['aqua600', 'green500', 'blue500', 'purple500', 'gray200'])
} : {};
Avatar.defaultProps = {
  fullName: '',
  size: AVATAR_SIZES.lg,
  background: 'gray200'
};